import React from "react";
import { VolumeUpIcon } from "../../../common/icon";

interface AudioProps {
  audioPath: string;
  value: string;
  view?: () => void;
}
export const changeFormat = (url: any) => {
  return url.replace(".wav", ".mp3");
};
let isPlaying = false;
const createAudioComponent = ({ audioPath, value, view }: AudioProps) => {
  const handleAudioClick = () => {
    const audioTag = document.createElement("audio");
    audioTag.src = `${process.env.REACT_APP_PROGRESS_URL}/content/${changeFormat(audioPath)} `;
    if (!isPlaying) {
      audioTag.play();
    }
    audioTag.addEventListener("play", () => {
      isPlaying = true;
    });
    audioTag.addEventListener("ended", () => {
      isPlaying = false;
    });
  };

  return (
    <div className="audio-container">
      {audioPath !== "" && (
        <VolumeUpIcon className="audio-icon" data-testid={"audio-icon"} onClick={handleAudioClick} />
      )}
      <p onKeyDown={() => {}} className={`audio-icon-label ${view ? "blue" : ""}`} onClick={view}>
        {value}
      </p>
    </div>
  );
};

export default createAudioComponent;
